<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="project-files-tree col-lg-2 pt-3">
    <div class="project-files-tree__info">
      <div class="project-files-tree__action">
        <h6>{{ $t('file.files') }}</h6>
        <button
            class="project-files-tree__action-btn"
            type="button"
            @click="isSearchEnabled = !isSearchEnabled"
          >
            <i class="gf-icon" :class="{
              'gf-icon-search': isSearchEnabled == false,
              'gf-icon-x': isSearchEnabled == true
            }"></i>
          </button>
      </div>
      <gf-search-bar
            v-show="isSearchEnabled == true"
            class="project-files-tree__search"
            :selected-search="$route.query?.q"
            @submit="onSearchSubmit"
            :placeholder="$t('project.searchCode')"
      />
      <project-branch-selector
        v-if="selectedBranch || !hasSelectedBranch || selectedCommit"
        v-model="branchSelectorModel"
        :selected="selectedBranch || selectedCommit"
        :alias="alias"
        :project-model="projectAlias"
        :placeholder="$t('message.select_branch')"
        @input="onBranchSelectorInput"
      />
    </div>
    <ul class="project-files-tree__node-list">
      <project-files-tree-node
        v-for="(file, index) in files"
        v-if="files"
        :key="index"
        :node="file"
        :path-to-open="$route.query?.file?.split('/')"
        :spacing="0"
      />
    </ul>
  </div>
</template>

<script>
import RepoS from '@shared/services/repository.service';
// eslint-disable-next-line import/no-unresolved
import ProjectFilesTreeNode from './project-files-tree-node';
// eslint-disable-next-line max-len
import projectBranchSelector from '@/shared-modules/shared-components/shared/project-branch-selector';
import projectFilesMessages from '../project-files.messages';
import GfSearchBar from '@shared/shared-components/shared/filter/GfSearchBar';

export default {
  name: 'ProjectFilesTree',
  components: { ProjectFilesTreeNode, projectBranchSelector, GfSearchBar },
  props: {
    isNewRepo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      branchSelectorModel: null,
      selectedBranch: null,
      selectedCommit: null,
      hasSelectedBranch: true,
      isSearchEnabled: false
    };
  },
  computed: {
    branch() {
      return this.$route?.query?.branch || document.getElementById('currentBranch')?.value;
    },
    commit() {
      return this.$route?.query?.commit;
    },
    alias() {
      return this.$route?.params?.alias;
    },
    projectAlias() {
      return this.$route?.params?.projectAlias;
    },
    files() {
      return this.$store.getters.getNodeChildrenByPath('');
    },
    projectUuid() {
      return this.$store.getters.getProjectUuid;
    }
  },
  mounted() {
    if (this.commit) {
      this.selectedCommit = this.commit;
      this.branchSelectorModel = this.selectedCommit;
    } else if (this.branch) {
      this.hasSelectedBranch = true;
      this.selectedBranch = this.branch;
      this.branchSelectorModel = this.selectedBranch;
    } else {
      this.hasSelectedBranch = false;
    }

    this.isNewRepo ? null : this.getFiles();
  },
  methods: {
    getFiles() {
      RepoS.getRepositoryFiles(this.alias, this.projectAlias, this.alias, {
        branch: this.selectedBranch,
        commit: this.commit
      });
    },
    onBranchSelectorInput() {
      const branchTitle = this.branchSelectorModel?.title;
      const query = {};
      if (this.selectedCommit) {
        query.commit = undefined;
      }
      if (branchTitle !== this.branch) {
        query.branch = branchTitle;
      } else {
        query.branch = undefined;
      }
      this.$router.push({ name: 'project-files', query }).then(() => {
        window.location.reload();
      });
    },
    onSearchSubmit(data) {
      if (data) {
        window.location.href=`/search/code/repo?q=${data}&projectUuid=${this.projectUuid}&page=0`
      }
    },
  },
  i18n: { messages: projectFilesMessages }
};
</script>

<style lang="scss">
$this: '.project-files-tree';

#{$this} {
  background-color: var(--light);
  border-right: 1px solid var(--border-color);
  border-top-left-radius: var(--border-radius-lg);
  border-bottom-left-radius: var(--border-radius);

  @media screen and (max-width: 992px) {
    border-right: none;
    border-bottom: 1px solid var(--border-color);
    border-top-right-radius: var(--border-radius-lg);
    border-bottom-left-radius: 0;
  }

  #{$this}__info {
    margin-bottom: 16px;



    #{$this}__action {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      & h6 {
        margin: 0;
        line-height: 1;
      }

      &-btn {
        background-color: rgba(255, 255, 255, 0);
        border: none;
        outline: none;
        padding: 9px;
        cursor: pointer;
        background-image: none;

        & i {
          font-size: 16px;
          color: var(--text);

          @media screen and (max-width: 992px) {
            font-size: 20px;
          }
        }
      }
    }

    #{$this}__search {
      background-color: var(--white);
      padding: 6px 8px !important;
      margin-bottom: 8px;
    }


    .gf-search-bar input {
      padding-right: 9px !important;
    }

    .gf-search-bar i {
      font-size: 16px !important;

      @media screen and (max-width: 992px) {
        font-size: 20px !important;
      }
    }

    .v-select .vs__actions {
      padding-right: 9px !important;

      & img {
        width: 16px;

        @media screen and (max-width: 992px) {
          width: 20px;
        }
      }
    }
  }

  #{$this}__node-list {
    height: calc(100% - 80px);
    padding-left: 0;
    display: flex;
    flex-direction: column;
    overflow: auto;
    list-style: none;
  }

  .select-branch {
    @media screen and (min-width: 992px) {
      min-width: 80px !important;
    }
  }
}
</style>
